// GET

import axios from 'axios';

// ewosapi/v1/delivery-board/{customerErpId}/document?orderNumber={orderNumber}&documentId={documentId}
export const getOrderHistoryDeliveryDocumentation = async (
  globalCompanyId: string,
  orderNumber: string,
  documentId: string
): Promise<Blob> => {
  const res = await axios.get(`/ewosapi/v1/order/analytics/${globalCompanyId}/orderhistory/${orderNumber}/document/${documentId}`, {
    responseType: 'blob',
  });

  return res.data;
};
